module.exports = __webpack_public_path__ + "static/media/21.e5e227b7.jpeg";